import {AnalysisGraphQL} from 'analysis-tool/AnalysisTypes';
import {getStepFromAnalysis} from 'analysis-tool/data/getStepFromAnalysis';
import {
  AnalysisMainViewItem,
  AnalysisMainViewItemType,
  DataReference,
} from 'analysis-tool/ui/main-view/MainViewTypes';
import configureAndApplyStaticTemplate from 'pipelines/static-templates/configureAndApplyStaticTemplate';
import {StaticTemplateId} from 'pipelines/static-templates/GeneratedStaticTemplateUIShapes';

export interface CreateViewAndOpenExperimentOptimizationViewParams {
  analysis: AnalysisGraphQL;
  inputDataFrameId: string;
  inputDataReference: DataReference;
  onOpenStepInitializationView: (newSelectedItem: AnalysisMainViewItem) => void;
}

export default function createViewAndOpenExperimentOptimizationView({
  analysis,
  inputDataFrameId,
  inputDataReference,
  onOpenStepInitializationView,
}: CreateViewAndOpenExperimentOptimizationViewParams): void {
  const inputStep = getStepFromAnalysis(analysis, inputDataReference.stepId);
  const outputStepData = inputStep.outputStepDatas.find(
    (outputStepData) => outputStepData.name === inputDataReference.stepDataName
  )!;
  const inputDataFrameIndex = outputStepData.rawDatas.findIndex((rawData) => rawData.id === inputDataFrameId);

  configureAndApplyStaticTemplate(
    StaticTemplateId.EXPERIMENT_OPTIMIZATION,
    analysis.id,
    [
      {
        step: inputStep,
        stepDataName: inputDataReference.stepDataName,
        rawDataIndex: inputDataFrameIndex,
      },
    ],
    (newSteps) => {
      onOpenStepInitializationView({
        type: AnalysisMainViewItemType.DATA_VIEW,
        viewReference: {
          stepId: newSteps[0].id,
          outputReference: {
            stepDataName: newSteps[0].outputStepDatas[0].name,
            rawDataIndex: 0,
          },
        },
      });
    }
  );
}
